
















import LoadingSpinner from './LoadingSpinner.vue'

export default {
  components: {
    LoadingSpinner
  },
  props: {
    updatesCount: {
      validator: prop => typeof prop === 'number' || prop === null,
      default: null
    }, // TODO: change to number and make required after updates counter is implemented for all pages
    loading: { type: Boolean, default: false }
  },
  computed: {
    refreshButtonText() {
      return this.updatesCount === null
        ? this.$t('table.updatesRefresh.noCount')
        : this.$t('table.updatesRefresh', {
            count: this.updatesCount
          })
    }
  },
  methods: {
    onClick() {
      if (!this.$route.query.page || this.$route.query.page === 1 || !this.updatesCount) {
        this.$emit('click-refresh', this.$route.query)
      } else {
        // In case of an active pagination the pagination component listens to query param changes and handles update
        this.$router.push({ query: { ...this.$route.query, page: 1 } })
      }
    }
  }
}
